import { combineReducers } from 'redux';

import patients from './patients/reducer';
import settings from './settings/reducer';

export default combineReducers({
  patients,
  settings,
});
